/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as WaterfallLayerSpec } from '../../../../layer/preset/bar/waterfall';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface WaterfallLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type WaterfallLayerType = StandardChartLayerSpec &
  WaterfallLayerSpec &
  WaterfallLayerTypeWithFields;

// 创建瀑布图数据类型验证器
const validateWaterfallDataTypes = createDataTypeValidator('waterfall', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'y2', type: ['string', 'date'] }
]);

// 创建瀑布图编码验证器
const validateWaterfallEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'y2' }
]);

// 额外的检查函数
const additionalWaterfallChecks = (layer: WaterfallLayerType, data: Data) => {
  const { encoding, type } = layer;
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  // 检查数据量是否足够（瀑布图需要至少3个数据点才有意义）
  if (values.length < 3) {
    utils.logger.warn(
      'warning',
      `The "${type}" layer requires at least 3 data points to form a meaningful waterfall chart`
    );
  }

  if (!values.length) {
    return;
  }

  // 按y2字段分组
  const groups = {} as Record<string, unknown[]>;
  values.forEach(item => {
    const timeKey = String(item[encoding.y2]);
    groups[timeKey] = groups[timeKey] || [];
    groups[timeKey].push(item);
  });

  // 检查每组是否至少有3个数据点
  const hasValidGroup = Object.values(groups).some(group => group.length >= 3);

  if (!hasValidGroup) {
    utils.logger.warn(
      'warning',
      `The "${type}" layer requires at least one time group with 3 or more data points`
    );
  }
};

// 创建并导出瀑布图处理器
export const waterfall = createLayerProcessor<WaterfallLayerType>(
  'waterfall',
  validateWaterfallEncoding,
  validateWaterfallDataTypes,
  additionalWaterfallChecks
);
